import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '@rp/environments';
import { StructureResponse } from '@rp/shared/models';
import { Observable } from 'rxjs';
import { LocalStorageService } from '@rp/shared/services';

import { PersonalInfo } from '../models';
import { PERSONAL_INFO } from '../constants';

@Injectable({ providedIn: 'root' })
export class StructuresService {
  private readonly _http = inject(HttpClient);
  private readonly _localStorageService = inject(LocalStorageService);

  getStructures(): Observable<StructureResponse> {
    const personalInfo: PersonalInfo = this._localStorageService.getValue(PERSONAL_INFO);
    const userType = personalInfo.userType;
    const apiHost = environment.apiConfig[userType === 'admin' ? 'adminApiHost' : 'userApiHost'];

    return this._http.get<StructureResponse>(`${apiHost}/structures/`);
  }
}
